import * as Sentry from '@sentry/react';
import { useEffect } from 'react';

import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';
import { isDevEnv } from '../manager/host-manager';

// function captureMessage(message) {
//   Sentry.captureMessage(message);
// }

function sentrySetup() {
  if (isDevEnv) return;

  const tracesSampleRate = 0.2;

  Sentry.init({
    dsn: 'https://731218daa5be4ab393db5621937e6e75@o4504587122900992.ingest.sentry.io/4504587126177794',

    // debug: isDevEnv,
    // enabled: !isDevEnv,

    enabled: true,

    integrations: [
      Sentry.browserTracingIntegration({
        // See docs for support of different versions of variation of react router
        // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
        routingInstrumentation: Sentry.reactRouterV6BrowserTracingIntegration(
          useEffect,
          useLocation,
          useNavigationType,
          createRoutesFromChildren,
          matchRoutes
        ),
      }),
    ],

    // replaysSessionSampleRate: 0,
    // replaysOnErrorSampleRate: 1.0,
    // integrations: [new BrowserTracing(), new Sentry.Replay()],
    // tracesSampler: (context) => {
    //   console.log(JSON.stringify(context, null, '  '));
    //   return tracesSampleRate;
    // },

    tracesSampleRate,
  });
}

// export { sentrySetup, captureMessage };
export { sentrySetup };
